import * as ActionTypes from './action-types';
import fonts from '../../constants/fonts';

import { loadWebFont } from '../../utils/fonts';

export function loadFont(fontIndex) {
  const font = fonts[fontIndex];

  return (dispatch) => {
    dispatch({ type: ActionTypes.LOAD_FONT_REQUEST });

    loadWebFont(font, (success) => {
      if (success) {
        dispatch({
          type: ActionTypes.LOAD_FONT_SUCCESS,
          payload: {
            fontIndex,
          },
        });
      } else {
        dispatch({
          type: ActionTypes.LOAD_FONT_FAILURE,
          payload: {
            fontIndex,
          },
        });
      }
    });
  };
}

export function nextFont() {
  return (dispatch, getState) => {
    const state = getState();
    const nextFontIndex = (state.currentFontIndex + 1) % fonts.length;

    dispatch(loadFont(nextFontIndex));
  };
}

export function changeFont(fontIndex) {
  return (dispatch) => {
    dispatch(loadFont(fontIndex));
  };
}
